import { ChangeDetectorRef, Component, ComponentRef, ElementRef, HostBinding, ViewChild, ViewContainerRef } from '@angular/core';
import { WIZ_EVENT_TYPE, WizMathUtils } from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  WizButton,
  WizComponentManager,
  WizDatasource,
  WizDateField,
  WizFocusManager,
  WizIcon,
  WizLabel,
  WizPopUp,
  WizRoot,
  WizTranslationInput,
  WizTree,
  WizValidationContainerDirective,
  WizVgroup,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { PermissionAccess, StyleEngine } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { ChronoCodeLevelVO } from '@wizeoo/akm-common-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { ChronocodeLevelRenderer } from '../renderer/edit/chronocode-level.renderer';
import { ChronocodeTreeRenderer } from '../renderer/edit/chronocode.tree.renderer';
import { PermissionVisibility, StaticFeatureEnum } from '@wizeoo/akm-common-lib';
import { ViewData } from '@wizeoo/akm-common-lib';
import { ChronocodeVO } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { ColorPickerPop } from '@wizeoo/akm-common-lib';

/**
 * Vue d'administation des éléments de chronocodes
 * Author : SVA
 */
@Component({
  selector: 'chronocode-element-view',
  templateUrl: './chronocode-element.view.html',
})
export class ChronocodeElementView extends BaseView {
  @HostBinding('style.padding') forcedNoPadding = 'padding: 0px !important'; // c'est une vue enfant
  
  
  // Groupe contenant l'arbre de chronocodes pour l'écoute d'événement de sélection en mode capture
  // @ViewChild('vgTreeContainer', { read: ElementRef, static: false }) vgTreeContainer: ElementRef;
  @ViewChild('vgTreeContainer', { read: WizTree, static: false }) vgTreeContainer: WizTree<ChronocodeVO>;
  /** filtre du tree  */
  @ViewChild('vgTreeContainerFilter', { read: FilterComponent, static: false }) vgTreeContainerFilter: FilterComponent;

  /** Zone de detail */
  @ViewChild('vgDetailZone', { read: WizVgroup }) vgDetailZone: WizVgroup;
  /** Zone de validation des champs de saisie */
  @ViewChild('vgDetailZone', { read: WizValidationContainerDirective, static: false })
  private editionContainer: WizValidationContainerDirective;
  /** Composant de saisie du libellé */
  // @ViewChild('tiLevelLabelTrs', { read: WizTranslationInput, static: false }) tiLevelLabelTrs: WizTranslationInput;
  /** Libellé code du chronocode parrent */
  @ViewChild('lblParentCode', { read: WizLabel, static: false }) lblParentCode: WizLabel;
  /** Libellé du code court */
  @ViewChild('lblShortCode', { read: WizLabel, static: false }) lblShortCode: WizLabel;
  /** Libellé du code */
  @ViewChild('lblCode', { read: WizLabel, static: false }) lblCode: WizLabel;
  /** Composant de saisie du code */
  // @ViewChild('tiShortCode', { read: WizTextInput, static: false }) tiShortCode: WizTextInput;
  /** Composant de saisie du code */
  // @ViewChild('tiCode', { read: WizTextInput, static: false }) tiCode: WizTextInput;
  /** Composant de saisie du libellé */
  @ViewChild('tiLabelTrs', { read: WizTranslationInput, static: false }) tiLabelTrs: WizTranslationInput;
  /** Composant de saisie de la date de début */
  @ViewChild('dfStartDate', { read: WizDateField, static: false }) dfStartDate: WizDateField;
  /** Composant de saisie de la date de fin */
  @ViewChild('dfEndDate', { read: WizDateField, static: false }) dfEndDate: WizDateField;
  /** Libellé nb de jours */
  @ViewChild('lblNbDays', { read: WizLabel, static: false }) lblNbDays: WizLabel;
  /** Libellé nb se samedis */
  @ViewChild('lblNbSaturdays', { read: WizLabel, static: false }) lblNbSaturdays: WizLabel;
  /** Libellé nb de dimanches */
  @ViewChild('lblNbSundays', { read: WizLabel, static: false }) lblNbSundays: WizLabel;

  // Bouton OK
  @ViewChild('btOk', { read: WizButton, static: false }) btOk: WizButton;
  // Bouton rollback
  @ViewChild('btCancel', { read: WizButton, static: false }) btCancel: WizButton;

  // container d'ajout des niveaux de FDs
  @ViewChild('containerLevels', { read: ViewContainerRef, static: true }) containerLevels: ViewContainerRef; // container d'ajout des levels

  /** couleur de fond */
  @ViewChild('blockBack') blockBack: ElementRef; // zone de dessin de la couleur de background


  /** les champs de saisie des niveaux */
  public lvlComponents: ComponentRef<ChronocodeLevelRenderer>[] = [];

  public actionTreeRenderer: any = ChronocodeTreeRenderer;

  /** Data source de l'arbre des chronocodes */
  public chronocodeDS: WizDatasource<ChronocodeVO> = new WizDatasource<ChronocodeVO>([])
    .setHierarchical(true)
    .setItemCodeField('code')
    .setItemParentCodeField('subTreeParentCode')
    .setSortFields([{ property: 'startDate', way: 'asc', numeric: true }])
    .setSelectionMode('single')
    .setFilter(this.chronoFilterFunc.bind(this))
    .build();


  /** affichage ou non du panneau detail */
  public showDetail: boolean = false;

  private localRoot: ChronocodeVO = null;

  /** 
   * Clone de travail (élément de chrono en cours) 
   * ce n'est PAS le chronocode principal sélectionné dans la liste de gauche
   * c'est le chronocode 'détail' en cours d'édition
  */
  private localClone: ChronocodeVO = null;



  /** flag d'affichage de la zone d'édition des éléments */
  public hasSelected: boolean = false;

  constructor(elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super(elementRef);
  }

  /* ################################################
                      cycle de vie
   ################################################ */

  /** Alimentation des données */
  public wizSynchronizeData(): void {
    super.wizSynchronizeData();
    ViewData.wizUpdateModel = false;
  
      super.managePermissions([
        {
          feature: StaticFeatureEnum.CHRONOCODE,
          permissions: [
            {
              component: this.vgDetailZone,
              accesses: [PermissionAccess.READ],
              visibility: PermissionVisibility.DISABLED,
            },
          ],
        },
      ]);

      this.hasSelected = false; // Dans le cas on où on change de chronocode dans la vue principale

      const chronos: ChronocodeVO[] = Model.getInstance().chronocodeEngine.flatChronoFamily(Model.getInstance().currentChronocode); // c'est un clone, en fait
      this.localRoot = chronos[0];



      this.chronocodeDS.setSource(chronos);
      this.chronocodeDS.expandAll();
      this.buildFilter();

      this.manageLevels(); // gestion de la zone d'édition des niveaux
      this.manageComponentAccess();
  }

  /**
   * construction de la zone de filtre des chronocodes
   * @param event : Evenement de changement dans le text input de filtre
   */
  private buildFilter(): void {
    this.vgTreeContainerFilter.configure(['labelAndDates', 'startDateStr', 'endDateStr'], null, null);
    // le contextEngine prend le relais pour alimenter les filtres par défaut
    // this._context.feedFilterContext(this.vgTreeContainerFilter, 'CHRONO_TREE_FILTER');
  }

  /**
   * Ajout des listeners
   */
  public wizAddListener(): void {
    super.wizAddListener();
    // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.elementRef, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);

    // merge (create / update sur btOk)
    WizEventManager.addListener(this, this.btOk, WIZ_EVENT_TYPE.CLICK, this.doMerge);
    WizEventManager.addListener(this, WizRoot.root(), WIZ_EVENT_TYPE.GLOBAL_ENTER_KEY, this.doMerge);

    // revert (btCancel)
    WizEventManager.addListener(this, this.btCancel, WIZ_EVENT_TYPE.CLICK, this.doRevert);
    WizEventManager.addListener(this, WizRoot.root(), WIZ_EVENT_TYPE.GLOBAL_BACK_KEY, this.doRevert);
    WizEventManager.addListener(this, this.vgTreeContainerFilter, WIZ_EVENT_TYPE.CHANGE, this.filterTree); // modification du filtre

    WizEventManager.addListener(this, this.vgTreeContainer, WIZ_EVENT_TYPE.SELECTION_CHANGING, this.askSelectFromTree, { capture: true });
  }

  /**
   * Suppression des listeners
   */
  public wizRemoveListener(): void {
    super.wizRemoveListener();
    WizEventManager.removeListener(this, this.elementRef, WIZ_EVENT_TYPE.MODEL_UPDATE);

    WizEventManager.removeListener(this, this.btOk, WIZ_EVENT_TYPE.CLICK);
    WizEventManager.removeListener(this, WizRoot.root(), WIZ_EVENT_TYPE.GLOBAL_ENTER_KEY);

    WizEventManager.removeListener(this, this.btCancel, WIZ_EVENT_TYPE.CLICK);
    WizEventManager.removeListener(this, WizRoot.root(), WIZ_EVENT_TYPE.GLOBAL_BACK_KEY);
    WizEventManager.removeListener(this, this.vgTreeContainerFilter, WIZ_EVENT_TYPE.CHANGE); // modification du filtre
    WizEventManager.removeListener(this, this.vgTreeContainer, WIZ_EVENT_TYPE.SELECTION_CHANGING);
 

  }

  /** mémorisation du filtre */
  wizOnDestroy(): void {
    // this._context.saveLocalFilter(this.mainFilter, 'CHRONO_TREE_FILTER');
  }

  /** modification du filtre */
  private filterTree(e: WizEvent): void {
    this.chronocodeDS.refresh();
  }

  /**
   * filtre des chrono
   * @param item ChronocodeVO
   * @returns boolean, true si l'element correspond au filtre, false sinon
   */
  private chronoFilterFunc(item: ChronocodeVO): boolean {
    return this.vgTreeContainerFilter.checkVisible(item);
  }



  /* ################################################
                      interactions
   ################################################ */

  /** demande de changement de sélection depuis le tree */
  private askSelectFromTree(e: WizEvent = null): void {
    if (ViewData.wizUpdateModel) {
      let errors = this.editionContainer.check(true, true);
      if (errors && errors.length === 0) {
        // Vérification de la saisie
        this.doSelectFromTree(e.value);
      } else {
        e.preventDefault();
        WizPopUp.toast('$.chronocode.toast.edit.error.$', WizIcon.TOAST_ERROR).show();
      }
    } else {
      this.doSelectFromTree(e.value);
    }
  }

  /** sélection d'un chronodoce depuis le tree  */
  private doSelectFromTree(chronocode: ChronocodeVO): void {
    this.setSelect(this.chronocodeDS.isSelected(chronocode) ? null : chronocode);
    this.feed();
  }

  /** définition de l'élément sélectionné et création de son clone de travail */
  private setSelect(chronocode: ChronocodeVO): void {
    this.hasSelected = !!chronocode;
    this.localClone = chronocode; // ChronocodeEngine.cloneChronocode(chronocode); // alimentation du clone de travail (et oui, un clone de clone)
    // ViewData.wizUpdateModel = false; // reset du changement de modèle (on travaille élément par élément)
  }

  /** alimentation des champs de la vue avec les données du clone */
  private feed(): void {
    if (!this.localClone) {
      this.reset();
    } else {
      this.lblParentCode.wizLabel = this.localClone.parentCode ? this.localClone.parentCode : ' ';
      this.lblCode.wizLabel = this.localClone.code;
      this.lblShortCode.wizLabel = this.localClone.shortCode;
      this.tiLabelTrs.translationData = Model.getInstance().localeEngine.buildTranslationData(this.localClone.labelVO);

      this.dfStartDate.wizNumberValue = this.localClone.startDate ? this.localClone.startDate : NaN;
      this.dfEndDate.wizNumberValue = this.localClone.endDate ? this.localClone.endDate : NaN;
      Model.getInstance().chronocodeEngine.computeChronocodeDays(this.localClone); // calcul des nb jours / samedis / dimanches
      this.lblNbDays.wizLabel = this.localClone.nbDaysStr;
      this.lblNbSaturdays.wizLabel = this.localClone.nbSaturdaysStr;
      this.lblNbSundays.wizLabel = this.localClone.nbSundaysStr;

      // couleur des barres de menu
      if (!!this.localClone.color) {
        this.backgroundColor = this.localClone.color;
      } else {
        this.backgroundColor = StyleEngine.STYLE_DEFAULT_BACKGROUND_COLOR;
      }

    }
    this.manageComponentAccess();
    this.focusDetail();
  }

  /** gestion de la visibilité des champs / zone selon l'état */
  private manageComponentAccess(): void {
    this.showDetail = !!this.localClone;
    this.dfStartDate.wizDisabled = this.localClone && this.localClone.exist;
    this.dfEndDate.wizDisabled = this.localClone && this.localClone.exist;

    if (ViewData.wizUpdateModel) {
      this.btOk.wizDisabled = false;
      this.btCancel.wizDisabled = false;
    } else {
      this.btOk.wizDisabled = true;
      this.btCancel.wizDisabled = true;
    }
  }

  /** Reset de la partie détail */
  private reset(): void {
    this.lblParentCode.wizLabel = ' ';
    this.lblCode.wizLabel = ' ';
    this.lblShortCode.wizLabel = ' ';
    this.tiLabelTrs.translationData = null;
    this.dfStartDate.wizNumberValue = NaN;
    this.dfEndDate.wizNumberValue = NaN;
    // informations complémentaires
    this.lblNbDays.wizLabel = ' ';
    this.lblNbSaturdays.wizLabel = ' ';
    this.lblNbSundays.wizLabel = ' ';
  }

  /** Focus dans la vue de detail */
  private focusDetail(): void {
    if (!!this.localClone) {
      // seulement si un clone, sinon on garde le focus dans le tree
      WizFocusManager.getInstance().wizSetFocus(this.tiLabelTrs);
    }
  }

  /** change sur la zone détail, mise à jour éventuelle de l'updateModel, mise à jour du clone */
  private updateModel(e: WizEvent = null): void {
    if (e && e.value instanceof ChronocodeLevelRenderer) {
      // interception des opération sur titre de niveau
      // identifier le bon level
      const lvl: ChronoCodeLevelVO = this.localRoot.levelsVOMap.get(e.value.data.level);

      // console.log('update chrono level', lvl, e.value.updatedEntry);

      lvl.labelVO.updateTranslationEntry(e.value.updatedEntry);
      this.localRoot.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
      ViewData.wizUpdateModel = true;
      this.manageComponentAccess(); // mise à jour des compos d'interaction
    } else if (e && e.component) {
      switch (e.component) {
        case this.tiLabelTrs: // seule la trad est disponible en update
          this.localClone.labelVO.updateTranslationEntry(e.value);
          ViewData.wizUpdateModel = true;
          this.manageComponentAccess(); // mise à jour des compos d'interaction
          break;
      }
    }
  }

  /**
   * demande d'annulation des modifications
   * @param e, wizevent
   */
  public doRevert(e: WizEvent = null): void {
    this.wizSynchronizeData();
  }

  /** demande de merge sur btOk */
  private doMerge(): void {
    let errors = []; //  this.editionContainer.check(true, true);
    if (this.localClone) {
      errors = this.editionContainer.check(true, true);
    }

    // gestion manuelle des libellés manquant sur level, process de validation marche pas en dynamique...
    this.localRoot.levelsVO.forEach((lvlVO: ChronoCodeLevelVO) => {
      if (!lvlVO.trsLabel || lvlVO.trsLabel.length === 0) {
        errors.push({ wizError: 'missing level label', wizErrorParams: [lvlVO.level] });
      }
    });

    if (errors && errors.length === 0) {
      // Vérification de la saisie
      // ChronocodeEngine.merge(this.clone, ChronocodeEngine.getChronocode(this.clone.code), this.backFromMerge.bind(this));
      Model.getInstance().chronocodeEngine.chronocodeMerge(this.chronocodeDS.getSource(), this.backFromMerge.bind(this));
    } else {
      WizPopUp.toast('$.chronocode.toast.edit.error.$', WizIcon.TOAST_ERROR).show();
    }
  }

  /**
   * Retour de service merge
   * @param bddBack chronocode retourné, ou rien... pas fiable
   */
  private backFromMerge(bddBack: any): void {
    this.wizSynchronizeData();

    // DataEngine.clearLoadedFEI(null, ChronocodeEngine.currentEditedChronocode, null); // nettoyage des FEI contenant le chrono

    WizEventManager.dispatchEvent(
      WizRoot.root(),
      new AlkEvent(ALK_EVENT_TYPE.CHRONO_LABEL_CHANGE, Model.getInstance().currentChronocode)
    );
  }

  /* ################################################
                 gestion des levels
   ################################################ */

  /** suppression des champs de saisie Level */
  private clearLevels(): void {
    if (!!this.lvlComponents && this.lvlComponents.length > 0) {
      this.containerLevels.clear(); // vider le container
      this.lvlComponents = []; // on rince la référence aux saisies de levels
    }
  }

  /** alimente le FDV (sur select)  */
  private manageLevels() {
    this.clearLevels();
    if (!!this.localRoot) {
      this.localRoot.levelsVO.forEach((lvlVO: ChronoCodeLevelVO) => {
        const meCompo: ComponentRef<ChronocodeLevelRenderer> = WizComponentManager.instance.addChildTo(
          ChronocodeLevelRenderer,
          this.containerLevels,
          { instanceProperties: { data: lvlVO } }
        );
        this.lvlComponents.push(meCompo);
      });
    }
  }

 /* ##############################################################################
                   gestion du colorPicker pour la conf du header
     ############################################################################## */

  public backgroundColor = StyleEngine.STYLE_DEFAULT_BACKGROUND_COLOR; // --grid-header-background-color

  /**
   * affichage de la popUp du colorPicker
   * @param pEvent click
   */
  public showColorPicker(pEvent: Event): void {
    pEvent.stopPropagation();
    pEvent.preventDefault();
    ColorPickerPop.show(this.blockBack.nativeElement, pEvent.target, this.backgroundColor, this.backFromPicker.bind(this));
  }

  /**
   * retour de colorPicker, alimentation des couleurs du header
   *
   * @param target le span source pour font ou background
   * @param color la couleur du picker
   */
  public backFromPicker(target: any, color: string): void {
    this.backgroundColor = color;
    this.feedHeaderStyle();
  }

  /** alimentation des slots de couleurs pour le header */
  public feedHeaderStyle(): void {
    this.localClone.color = this.backgroundColor;
    ViewData.wizUpdateModel = true;
    this.manageComponentAccess();
    // WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
    this.cdref.markForCheck();
  }

  /** click sur les icones de suppression de style de header */
  public resetColor(who: string): void {
    this.backgroundColor = StyleEngine.STYLE_DEFAULT_BACKGROUND_COLOR; // --grid-header-background-color
    this.feedHeaderStyle();
  }


}
